module.exports = __webpack_public_path__ + "static/testimonials-hero.c6df04c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/testimonials-hero.png
// module id = 986
// module chunks = 208176855801404